import ClassListResourcePagingResultModel from '../../generated/types/model/resource/ClassListResourcePagingResultModel';

import ISchedulerList from '../interfaces/ISchedulerList';
import BaseSchedulerListResultMixin from '../mixin/BaseSchedulerListMixin';

export default class ClassListResourcePagingResultViewModel extends BaseSchedulerListResultMixin(ClassListResourcePagingResultModel) implements ISchedulerList {
  protected transformToDTO() {}

  protected transformFromDTO() {}
}
